<template>
  <el-dialog v-if="showoff" :visible.sync="showoff" title="设置商品上下架" width="500px">
    <div class="top">
      <el-button type="primary" size="mini" @click="batchSet(1)">批量上架</el-button>
      <el-button size="mini" @click="batchSet(0)">批量下架</el-button>
    </div>
    <el-table
      :data="tableData"
      class="tableBox"
      border
      style="width: 100%"
      :header-cell-style="{
        background: '#f5f7fa',
      }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="40" align="center"/>
      <el-table-column
        prop="outSysCodeName"
        label="平台名称"
        align="center"
      />
      <el-table-column
        label="商品上下架"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isOnSale"
            :active-value="1"
            :inactive-value="0"
            active-color="#1890ff"
            inactive-color="#d1d6dd"
            @change="
                  (e) => {
                    switchStatus(e, scope.row);
                  }
                "
          />
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      showoff: false,
      selects: [], //选择的数据
      tableData: [],
    };
  },
  methods: {
    show(row) {
      this.row = row;
      this.showoff = true;
      this.getGoodsStatus(row.goodsId);
    },
    close() {
      this.showoff = false;
    },

    handleSelectionChange(val) {
      this.selects = val;
    },

    /**
     * 批量设置上下架
     * @param isOnSale
     */
    batchSet(isOnSale) {
      if (!this.selects.length) {
        this.$message({type: 'error', message: '请先选择平台后再试'});
        return;
      }

      this.setGoodsOnOffStatus(this.selects[0].goodsId, isOnSale, this.selects.map(it => it.outSysCode))

    },

    switchStatus(e, row) {
      console.log('switchStatus: ', e, row)
      this.setGoodsOnOffStatus(row.goodsId, e, [row.outSysCode])
    },

    /**
     * 设置商品上下架
     */
    async setGoodsOnOffStatus(goodsId, isOnSale, platforms) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      await this.$axios.post(this.$api.supplychain.setGoodsOnOffStatus, {
        goodsId: goodsId,
        isOnSale: isOnSale,
        outSysCodeList: platforms
      })
        .then((res) => {
          this.getGoodsStatus(goodsId)
          loading.close()
          //如果接口请求不成功，则状态恢复
          // if (res.code !== 0) {
          //   this.tableData.find(it => it.goodsId === goodsId).isOnSale = isOnSale === 0 ? 1 : 0
          // }
        })
    },

    /**
     * 获取商品上下架状态
     * @param goodsId
     * @returns {Promise<void>}
     */
    async getGoodsStatus(goodsId) {
      const res = await this.$axios.get(this.$api.supplychain.getGoodsOnOffStatus, {params: {goodsId: goodsId}});
      if (res.code === 0) {
        this.tableData = res.data || {};
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.tableBox {
  :deep(.el-table__header) {
    .el-table__cell {
      font-weight: bold;
      color: #333;
    }
  }

  :deep(.el-table__row) {
    font-size: 12px;
  }
}

.top {
  margin-bottom: 20px;
}
</style>
